import React, { useState } from "react";
import "./App.css";
import Slogan from "./pages/Slogan";
import Landing from "./pages/Landing";
import leaf from "./assets/leaf.png";

function App() {
    const [enter, setEnter] = useState(false);
    const [aud, setAud] = useState(null);
    const [muted, setMuted] = useState(false);
    const [showMuteHint, setShowMuteHint] = useState(true);

    // Hide the mute hint after animation (2 blinks, ~2.2s)
    React.useEffect(() => {
        if (showMuteHint && enter) {
            const timer = setTimeout(() => setShowMuteHint(false), 11200);
            return () => clearTimeout(timer);
        }
    }, [showMuteHint, enter]);

    const handleMuteToggle = () => {
        const audio = document.getElementById("audio");
        if (audio) {
            if (!muted) {
                audio.pause();
            } else {
                audio.play();
            }
        }
        setMuted(m => !m);
    };

    return (
        <div
            style={{
                background: `linear-gradient(135deg, rgba(248, 255, 252, 0.7) 0%, rgba(224, 247, 250, 0.7) 50%, rgba(208, 248, 232, 0.7) 100%), url(${
                    enter ? null : leaf
                })`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundBlendMode: "lighten"
            }}
            className="App fade-in-medium"
        >
            <div
                style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    letterSpacing: "10px",
                    color: "#22643a",
                    width: "100vw",
                    fontFamily: "fantasy",
                    position: "absolute",
                    top: 10,
                    left: 0,
                    textAlign: "center",
                    textEmphasisStyle: "double-circle",
                    textEmphasisPosition: "under",
                    textShadow: "2px 2px 8px green"
                }}
                className="nidanam-head"
            >
                Nidānam
            </div>
            {enter ? (
                <>
                    <button
                        onClick={handleMuteToggle}
                        style={{
                            position: "fixed",
                            top: "-30px",
                            right: 15,
                            zIndex: 9999,
                            background: "rgba(255,255,255,0.85)",
                            border: "1px solid #43e97b",
                            borderRadius: 24,
                            padding: "4px 8px",
                            fontWeight: 700,
                            color: "#22643a",
                            boxShadow: "0 2px 8px 0 rgba(67, 233, 123, 0.10)",
                            cursor: "pointer"
                        }}
                    >
                        {muted ? "🔇" : "🎶"}
                    </button>
                    {showMuteHint && (
                        <div
                            className="mute-hint-label"
                            style={{
                                position: "fixed",
                                top: 28,
                                right: 63,
                                zIndex: 9998,
                                background: "#fff",
                                color: "#22643a",
                                border: "3px solid #43e97b",
                                borderRadius: 12,
                                padding: "4px 14px",
                                fontWeight: 600,
                                fontSize: 14,
                                boxShadow: "0 2px 8px 0 rgba(67, 233, 123, 0.10)",
                                animation: "mute-blink-fade 5s linear forwards"
                            }}
                        >
                            Mute ➡️
                        </div>
                    )}
                </>
            ) : null}
            <audio id="audio" src={aud} preload="auto" />
            {enter ? <Landing setAud={setAud} /> : <Slogan setEnter={setEnter} />}
        </div>
    );
}

export default App;
